
import React from "react";
import VendorSubNav from "../pages/Sales/Vendors/components/VendorSubNav";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const vendorArr = [
  {
    name: "Summary",
    link: "summary",
  },
  {
    name: "Details",
    link: "details",
  },
  {
    name: "Files",
    link: "files",
  },
];


const VendorsLayout = () => {
  // Read selected vendor from Redux
  const selectedVendor = useSelector((state) => state.vendor.selectedVendor);

  return (
    <div className="px-5">
      {/* Breadcrumbs removed: use BreadcrumbsSwitcher at a higher level */}
      <div className="border-b border-stone-300 flex gap-12 mt-5">
        {vendorArr.map(({ name, link }) => (
          <VendorSubNav key={link} name={name} link={link} />
        ))}
      </div>
      <Outlet />
    </div>
  );
};


export default VendorsLayout;
